import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES, TARGETS } from 'app-webtech-core/beacon/const';
import { getPlaybackData } from '../../player/beacons/helpers/getPlaybackData';

export const msnHeartBeatBeacon = (action, prevState, nextState) => ({
  hitType: HIT_TYPE.EVENT,
  targets: TARGETS.MSN,
  eventCategory: EVENT_CATEGORIES.WATCH,
  eventName: EVENT_NAMES.HEART_BEAT,
  value: action.payload.seconds,
  ...getPlaybackData(nextState),
});
